import { render } from "./AvatarSquareCircle.vue?vue&type=template&id=72d80c22"
import script from "./AvatarSquareCircle.vue?vue&type=script&lang=js"
export * from "./AvatarSquareCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__